import React from "react";


import "@/styles/scss/widgets/_notes.scss";

const NotesWidget = () => {
  return (
    <div className="notes-widget mb-3">
      <NotesHeader />
      <div className="body">
        <NoteItem />
        <NoteItem />
      </div>
    </div>
  );
};

NotesWidget.propTypes = {};

const NotesHeader = () => {
  return (
    <div className="header">
      <div className="row">
        <div className="col">
          <span className="title">Notes</span>
        </div>
        <div className="col text-end">
          <span className="text-danger fw-bold c-pointer">
            <i className="bi bi-sticky me-1" />
            Add note
          </span>
        </div>
      </div>
    </div>
  );
};

const NoteItem = () => {
  return (
    <div className="note-item d-flex align-items-top p-3">
      <div>
        <span className="avatar avatar-md online avatar-rounded bg-success">
          JT
        </span>
      </div>
      <div className="px-2">
        <div className="fw-medium fs-12">Authorization</div>
        <div className="fw-medium fs-10 mb-1">created by Ellen Waite</div>
        <div className="text-gray fs-10 mb-1">{new Date().toString()}</div>
        SSN provided on authorization form does not match was provided by property.
      </div>
      <div></div>
    </div>
  );
};

export default NotesWidget;
